// Spectral-inspired qualitative palette (ColorBrewer "Spectral" + one extra),
// replacing the abandoned chartjs-plugin-colorschemes (no Chart.js 4 support).
export const palette = [
  '#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b',
  '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2',
  '#b15928', '#1f78b4',
]

export function chartColor(index) {
  return palette[index % palette.length]
}
